<div class="pharmacy-card-skeleton">

  <div class="pharmacy-card-skeleton__header">
    <ngx-skeleton-loader [theme]="skeletonNameTheme"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="skeletonBadgeTheme"></ngx-skeleton-loader>
  </div>

  <div class="pharmacy-card-skeleton__details">
    <ngx-skeleton-loader [theme]="skeletonAddressTheme"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="skeletonPhoneTheme"></ngx-skeleton-loader>
  </div>

  <div class="pharmacy-card-skeleton__footer">
    <ngx-skeleton-loader [theme]="skeletonDistanceTheme"></ngx-skeleton-loader>
    <ngx-skeleton-loader [theme]="skeletonIconTheme"></ngx-skeleton-loader>
  </div>

</div>
